<template>
  <div class="validation-error" v-if="showAlert">
    <div class="validation-error__content">
      <div class="validation-error__icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.47 20.5037H19.53C21.07 20.5037 22.03 18.8337 21.26 17.5037L13.73 4.49372C12.96 3.16372 11.04 3.16372 10.27 4.49372L2.74 17.5037C1.97 18.8337 2.93 20.5037 4.47 20.5037ZM12 13.5037C11.45 13.5037 11 13.0537 11 12.5037V10.5037C11 9.95372 11.45 9.50372 12 9.50372C12.55 9.50372 13 9.95372 13 10.5037V12.5037C13 13.0537 12.55 13.5037 12 13.5037ZM13 17.5037H11V15.5037H13V17.5037Z" fill="#711B23"/>
          </svg>
      </div>
      <div class="validation-error__text">{{ resource['Label.GeneralErrorText'] /* Girdiğiniz bilgileri kontrol ediniz. */ }}</div>
    </div>
    <div class="validation-error__close" @click="showAlert=false">
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.3203 14.25L19.8359 10.7344C20.293 10.3125 20.293 9.60938 19.8359 9.1875L19.0625 8.41406C18.6406 7.95703 17.9375 7.95703 17.5156 8.41406L14 11.9297L10.4492 8.41406C10.0273 7.95703 9.32422 7.95703 8.90234 8.41406L8.12891 9.1875C7.67188 9.60938 7.67188 10.3125 8.12891 10.7344L11.6445 14.25L8.12891 17.8008C7.67188 18.2227 7.67188 18.9258 8.12891 19.3477L8.90234 20.1211C9.32422 20.5781 10.0273 20.5781 10.4492 20.1211L14 16.6055L17.5156 20.1211C17.9375 20.5781 18.6406 20.5781 19.0625 20.1211L19.8359 19.3477C20.293 18.9258 20.293 18.2227 19.8359 17.8008L16.3203 14.25Z" fill="#711B23"/>
        </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ValidationError',
  props: {
    show: { type: Boolean, required: true },
    fileUploaded: { type: Boolean, required: true },
    isValid: { type: Boolean, required: true },
  },
  data() {
    return {
      showAlert: false,
    };
  },
  methods: {
  },
  watch: {
    show (val) {
      if (val) {
        this.showAlert = false;
      } else {
        this.showAlert = true;
      }
    },
    isValid (val) {
      if (val && this.fileUploaded) {
        this.showAlert = true;
      } else {
        this.showAlert = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.validation-error {
  width: 852px;
  height: 60px;
  background: #F8D7DA;
  border: 1px solid #F6CACE;
  box-shadow: 2px 2px 12px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  position: fixed;
  top: 16px;
  z-index: 4999;

  &__content {
    display: flex;
    align-items: center;
  }

  &__text {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #711B23;
    margin-left: 8px;
  }

  &__close {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
}
</style>
